var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPatient(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "svg-icon",
    style: {
      width: "1em",
      height: "1em",
      verticalAlign: "middle",
      fill: "currentColor",
      overflow: "hidden"
    },
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M369.777778 398.222222v56.888889c0 79.644444 62.577778 142.222222 142.222222 142.222222s142.222222-62.577778 142.222222-142.222222v-56.888889H369.777778z m0-56.888889h284.444444c0-79.644444-62.577778-142.222222-142.222222-142.222222s-142.222222 62.577778-142.222222 142.222222z m34.133333 281.6c-79.644444 36.977778-136.533333 113.777778-145.066667 201.955556H824.888889v56.888889H199.111111v-28.444445c0-113.777778 62.577778-216.177778 159.288889-273.066666-28.444444-34.133333-45.511111-76.8-45.511111-125.155556v-113.777778c0-110.933333 88.177778-199.111111 199.111111-199.111111s199.111111 88.177778 199.111111 199.111111v113.777778c0 110.933333-88.177778 199.111111-199.111111 199.111111-39.822222 0-76.8-11.377778-108.088889-31.288889z",
    fill: "#3C3D44"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M739.555556 654.222222v-56.888889h56.888888v56.888889h56.888889v56.888889h-56.888889v56.888889h-56.888888v-56.888889h-56.888889v-56.888889z",
    fill: "#3C3D44"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPatient);
export default __webpack_public_path__ + "static/media/patient.b954cc711b6755baefb98c7e863cd522.svg";
export { ForwardRef as ReactComponent };